import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import { AUTH_CONSTANTS } from "../constants/auth";

export const useAuthRedirect = (): void => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useAuthContext();

  useEffect(() => {
    if (state.user?.isAuth) {
      const from =
        location.state?.from?.pathname || AUTH_CONSTANTS.DEFAULT_REDIRECT_PATH;
      navigate(from, { replace: true });
    }
  }, [state.user, navigate, location]);
};
